import axios, { AxiosInstance } from "axios";
import getTolgeeConfig from "./getTolgeeConfig";
import { logger } from "./logger";

const createTolgeeAxios = (): AxiosInstance => {
  const instance = axios.create({
    withCredentials: false,
    timeout: 15000,

    headers: {
      "Content-Type": "application/json",
    },
    baseURL: undefined,
  });
  return instance;
};

const tolgeeAxios = createTolgeeAxios();

const flattenTranslations = (obj: any, lang: string, parentKey = "", result: any = {}) => {
  Object.entries(obj).forEach(([key, value]) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    // console.log(`Processing key: ${newKey} with value:`, value);

    if (typeof value === "object" && value !== null) {
      flattenTranslations(value, lang, newKey, result);
    } else {
      result[newKey] = value;
    }
  });

  return result;
};

const getTranslations = async (
  lang: any,
  routeTags?: string[],
  hasExistingKeys = false,
): Promise<{ data: any; usedS3: boolean }> => {
  try {
    const tolgee_config = getTolgeeConfig(routeTags, lang, hasExistingKeys);
    const url = `${tolgee_config.tolgee_endpoint}`;
    const res = await tolgeeAxios.get(url, {
      headers: {
        "X-API-Key": tolgee_config.tolgee_api_key,
        Accept: "application/json",
      },
    });

    if (res.data?.params === null || res.data?.params === "null") {
      throw new Error("Invalid Tolgee API key");
    }

    if (res.data?.[lang]) {
      return { data: flattenTranslations(res?.data[lang], lang), usedS3: false };
    }
    return { data: {}, usedS3: false };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error(`Tolgee fetch failed for lang: ${lang}, error: ${errorMessage}`);
    logger.error("Error fetching tolgee translations:", error);
    try {
      let S3_TRANSLATIONS_URL = "";
      if (lang === "en") {
        S3_TRANSLATIONS_URL =
          "https://static-assets.amberstudent.com/tolgeekeys/v0/production/en.json";
      } else if (lang === "fr") {
        S3_TRANSLATIONS_URL =
          "https://static-assets.amberstudent.com/tolgeekeys/v0/production/fr.json";
      } else if (lang === "es") {
        S3_TRANSLATIONS_URL =
          "https://static-assets.amberstudent.com/tolgeekeys/v0/production/es.json";
      } else if (lang === "de") {
        S3_TRANSLATIONS_URL =
          "https://static-assets.amberstudent.com/tolgeekeys/v0/production/de.json";
      } else {
        // for zh ( will need to add lang checks based of langConfig moving forward )
        S3_TRANSLATIONS_URL =
          "https://oss-assets.amberstudent.cn/tolgeekeys/v0/production/zh-Hans.json";
      }
      const s3Res = await tolgeeAxios.get(S3_TRANSLATIONS_URL);
      return { data: s3Res.data, usedS3: true };
    } catch (s3Error) {
      logger.error("Error fetching S3 backup translations:", s3Error);
      throw new Error("Tolgee Endpoint and S3 Endpoint broke");
    }
  }
};

export default getTranslations;
